/**
 * @fileoverview Image Preloader - ゲームで使用される画像ファイルの事前読み込み
 * 主にCSS background-imageで使用される画像を対象とする
 */

import bluePiece from '../../../public/assets/images/pieces/blue.webp';
import greenPiece from '../../../public/assets/images/pieces/green.webp';
import purplePiece from '../../../public/assets/images/pieces/purple.webp';
import redPiece from '../../../public/assets/images/pieces/red.webp';
import yellowPiece from '../../../public/assets/images/pieces/yellow.webp';
import bomb from '../../../public/assets/images/special/bomb.webp';
import stripeH from '../../../public/assets/images/special/stripe_h.webp';
import stripeV from '../../../public/assets/images/special/stripe_v.webp';
import { MinimalErrorTracker } from '../shared/log.js';

const GAME_IMAGES = [
  redPiece,
  yellowPiece,
  bluePiece,
  greenPiece,
  purplePiece,
  stripeH,
  stripeV,
  bomb,
];

class ImagePreloader {
  constructor() {
    this.loaded = false;
    this.loadedImages = new Set();
    this.failedImages = new Set();
  }

  async preloadImage(src) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        this.loadedImages.add(src);
        resolve(src);
      };
      img.onerror = () => {
        this.failedImages.add(src);
        MinimalErrorTracker.warn('SYSTEM', `Image preload failed: ${src}`);
        reject(new Error(`Failed to preload: ${src}`));
      };
      img.src = src;
    });
  }

  async preloadAll() {
    if (this.loaded) return true;

    try {
      await Promise.all(GAME_IMAGES.map((src) => this.preloadImage(src)));
      this.loaded = true;
      return true;
    } catch (error) {
      MinimalErrorTracker.warn(
        'SYSTEM',
        `Images partially loaded: ${this.loadedImages.size}/${GAME_IMAGES.length}`,
        error,
      );
      this.loaded = this.loadedImages.size > 0;
      return this.loaded;
    }
  }

  getStats() {
    return {
      loaded: this.loaded,
      successCount: this.loadedImages.size,
      failureCount: this.failedImages.size,
      total: GAME_IMAGES.length,
    };
  }
}

const preloader = new ImagePreloader();

export async function initializeImagePreloader() {
  return await preloader.preloadAll();
}

export function getImageStats() {
  return preloader.getStats();
}

// 開発用デバッグインターフェース
if (typeof __PRODUCTION__ === 'undefined' || !__PRODUCTION__) {
  window.imagePreloader = {
    getStats: getImageStats,
    preload: () => preloader.preloadAll(),
  };
}
